import { BaseNode, BaseColumn } from 'types/transformation/types/nodes'
import DataType from 'types/transformation/enums/DataType'

import { getColumnName } from '../utils'

// A column reference in a stored expression, e.g. `1_input_amount`. Mirrors
// COLUMN_REF_PATTERN in the Glue job's sim/node/calculate_node.py, where `\w`
// covers non-ASCII letters that JavaScript's own `\w` leaves out.
const WORD = '\\w\\u0080-\\uFFFF'
const COLUMN_REF_REGEX = new RegExp(`(^|[^${WORD}@])(\\d+_[${WORD}]+)`, 'g')

/** The column ids a stored expression references. */
export const getExpressionRefs = (expression: string): string[] => {
  const refs: string[] = []

  // `_-_` (subtraction) is collapsed before ids are matched, in the same
  // order as the Glue job's parse_expression — an id token is otherwise
  // followed by a word character and never matches.
  expression
    .replace(/_-_/g, '-')
    .replace(COLUMN_REF_REGEX, (match, _delimiter: string, id: string) => {
      refs.push(id)

      return match
    })

  return refs
}

export const getNewColumn = (node: BaseNode): BaseColumn => {
  return {
    id: getColumnName(node.id, 'calculate_0'),
    name: '',
    reference_node: node.id,
    reference_node_index: node.index,
    type: DataType.DOUBLE
  }
}
